import React from 'react';
import leftStars from '../../assets/images/home_screen/left-stars.png';
import logo from '../../assets/images/home_screen/top-bar-logo.png';
import rightStars from '../../assets/images/home_screen/right-stars.png';
import { useNavigate } from 'react-router-dom';

const TopBar = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[85px] 2xl:h-[100px] w-full bg-[#4D535C] flex justify-between relative">
      <div className="bg-gradient-to-b from-transparent to-black/10 absolute w-full h-full" />
      <div className="relative">
        <img
          src={leftStars}
          alt="left-stars"
          className="w-[70%] sm:w-[400px] 2xl:w-[500px]"
        />
        <img
          src={logo}
          alt="logo"
          onClick={() => navigate('/')}
          className="w-[65px] 2xl:w-[80px] absolute top-2 right-3/4 sm:right-1/3 cursor-pointer"
        />
      </div>
      <div>
        <div className="absolute right-0 top-[8px] 2xl:top-[14px] overflow-hidden flex flex-col flex-start gap-[2px]">
          <div className="relative bg-gradient-to-r from-[#C672A7] to-[#7F76AF] h-[46px] w-[180px] rounded-tl-xl rounded-bl-xl">
            <div className="flex items-center px-3 absolute right-0 top-1/2 -translate-y-1/2 bg-[#75559E] h-[38px] w-[175px] rounded-tl-xl rounded-bl-xl">
              <a
                href="tel:+19073764880 "
                className="text-[20px] xl:text-[22px] font-[200] text-white tracking-wider mt-[1px] font-[Anton]"
              >
                907-376-4880
              </a>
            </div>
          </div>
          <p className="text-[16px] 2xl:text-[18px] font-[700] text-white tracking-wide px-[18px] whitespace-nowrap ">
            FAX 907-376-4885
          </p>
        </div>
        <img
          src={rightStars}
          alt="left-stars"
          className="hidden sm:block w-[500px]"
        />
      </div>
    </div>
  );
};

export default TopBar;
